import { Controller } from "@hotwired/stimulus"

/**
 * Delete Confirmation Controller
 *
 * Handles account deletion confirmation form validation.
 * Requires user to type "DELETE" to confirm account deletion.
 *
 * Usage:
 *   <form data-controller="delete-confirmation"
 *         data-action="submit->delete-confirmation#validate">
 *     <div data-delete-confirmation-target="error" class="hidden">...</div>
 *     <input data-delete-confirmation-target="input" ...>
 *   </form>
 */
export default class extends Controller {
  static targets = ["input", "error"]

  /**
   * Validate form before submission
   * Requires exact "DELETE" string to proceed
   * @param {Event} event - Form submit event
   */
  validate(event) {
    const value = this.inputTarget.value.trim()

    if (value !== "DELETE") {
      event.preventDefault()
      this.showError("請輸入「DELETE」以確認刪除帳號")
      this.inputTarget.focus()
      return false
    }

    this.hideError()
    return true
  }

  /**
   * Show error message and highlight input
   * @param {string} message - Error message to display
   */
  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
    this.inputTarget.classList.add("border-red-500", "ring-2", "ring-red-500")
  }

  /**
   * Hide error message and remove input highlight
   */
  hideError() {
    this.errorTarget.classList.add("hidden")
    this.inputTarget.classList.remove("border-red-500", "ring-2", "ring-red-500")
  }
}
